import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/index';
import { STORE_FEATURE_KEY_GLOBAL } from './global-settings.reducer';

const loadingIndicatorSelector = (appState: any) => appState[STORE_FEATURE_KEY_GLOBAL].loadingIndicator;
const statusToSatelliteSelector = (appState: any) => appState[STORE_FEATURE_KEY_GLOBAL].statusToSatellite;
const statusFromSatelliteSelector = (appState: any) => appState[STORE_FEATURE_KEY_GLOBAL].statusFromSatellite;
const clientModuleTypeSelector = (appState: any) => appState[STORE_FEATURE_KEY_GLOBAL].clientModuleType;
const strategyIdSelector = (appState: any) => appState[STORE_FEATURE_KEY_GLOBAL].strategyId;
const revertChangesSelector = (appState: any) => appState[STORE_FEATURE_KEY_GLOBAL].revertChanges;

@Injectable()
export class GlobalSettingsSelectors {
    constructor(private store: Store<any>) {
    }

    selectStatusToSatellite(): Observable<boolean> {
        return this.store
            .pipe(select(statusToSatelliteSelector));
    }

    selectStatusFromSatellite(): Observable<boolean> {
        return this.store
            .pipe(select(statusFromSatelliteSelector));
    }

    selectClientModuleType(): Observable<string> {
        return this.store
            .pipe(select(clientModuleTypeSelector));
    }

    selectLoadingIndicatorStatus(): Observable<boolean> {
        return this.store.pipe(select(loadingIndicatorSelector));
    }

    selectStrategyId(): Observable<number> {
        return this.store.pipe(select(strategyIdSelector));
    }

    selectRevertChanges(): Observable<boolean> {
        return this.store.pipe(select(revertChangesSelector));
    }
}
